const trapFocusHandlers = {};
const focusable_elements = [
    "summary",
    "a[href]",
    "button:enabled",
    ".popup-modal__content-info",
    "[tabindex]:not([tabindex^=" - "])",
    "[draggable]",
    "area",
    "input:not([type=hidden]):enabled",
    "select:enabled",
    "textarea:enabled",
    "object",
    "iframe",
].join(",");

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusable_elements));
}

function fetchSectionHTML(
    sectionId,
    useCache = false,
    path = window.location.pathname
) {
    const cacheKey = `${path}::${sectionId}`;

    if (typeof this.fetched === "undefined") this.fetched = {};

    if (useCache && this.fetched[cacheKey])
        return new Promise((resolve, reject) => {
            resolve(this.fetched[cacheKey]);
        });
    else {
        return fetch(
            path +
                (path.indexOf("?") === -1 ? "?" : "&") +
                `section_id=${sectionId}`
        )
            .then((result) => {
                if (result.ok) return result.text();
                else throw new Error(result.status);
            })
            .then((html) => {
                const innerHTML = new DOMParser()
                    .parseFromString(html, "text/html")
                    .querySelector(".shopify-section").innerHTML;

                if (useCache) this.fetched[cacheKey] = innerHTML;

                return innerHTML;
            });
    }
}

function fetchLoaderHTML() {
    return Promise.all([
        document.getElementById("template-loading-overlay")?.innerHTML,
    ]).then((results) => results[0]);
}

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus?.focus();
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
        );
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => {
        if (video.closest(".collage-video")) return;
        video.pause();
    });
    document
        .querySelectorAll("product-model")
        .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

function createFromTemplate(templateId) {
    return document
        .getElementById(templateId)
        .content.firstElementChild.cloneNode(true);
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options["hideElement"] || province_domid
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.bodyOverflowAttribute = "data-modal-opened";
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            "click",
            this.hide.bind(this)
        );
        this.addEventListener("click", (event) => {
            if (event.target.nodeName === "MODAL-DIALOG") this.hide();
        });
        this.addEventListener("keyup", () => {
            if (event.code?.toUpperCase() === "ESCAPE") this.hide();
        });
    }

    show(opener) {
        this.openedBy = opener;
        this.setAttribute("open", "");
        document.body.setAttribute(this.bodyOverflowAttribute, true);
        this.querySelector(".template-popup")?.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide() {
        this.removeAttribute("open");
        document.body.removeAttribute(this.bodyOverflowAttribute);
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");
        button?.addEventListener("click", () => {
            document
                .querySelector(this.getAttribute("data-modal"))
                ?.show(button);
        });
    }
}
customElements.define("modal-opener", ModalOpener);

(() => {
    let innerWidth = window.innerWidth;

    window.addEventListener(
        "resize",
        debounce(() => {
            if (innerWidth !== window.innerWidth) {
                innerWidth = window.innerWidth;
                publish(PUB_SUB_EVENTS.windowResizeX, undefined);
            }
        }, 200)
    );
})();

(function() {
  function removeARButtons() {
    // Only target AR buttons injected by Shopify inside model-viewer UI
    document.querySelectorAll('.shopify-model-viewer-ui__button--ar').forEach(el => el.remove());
  }

  const observer = new MutationObserver(removeARButtons);
  const start = () => {
    removeARButtons();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function initOdColletHubPage() {
  const path = window.location.pathname.replace(/\/$/, "");
  if (path !== "/collections/od-collet-chucks") return;

  function applyOdColletHub() {
    const banner = document.querySelector('[id*="image_with_text"]');
    if (!banner || banner.querySelector("#od-collet-hub-surface")) return;

    const sectionKey = banner.id.replace("shopify-section-", "");
    const pathWithQuery =
      window.location.pathname +
      (window.location.search ? window.location.search + "&" : "?") +
      `section_id=${sectionKey}`;

    fetch(pathWithQuery)
      .then((response) => response.text())
      .then((html) => {
        if (!html || html.indexOf("od-collet-hub-surface") === -1) return;
        banner.outerHTML = html;
      })
      .catch(() => {});

    document
      .querySelectorAll('[id*="collection_list_nrM3tr"], .collection-grid-section')
      .forEach((node) => node.remove());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyOdColletHub);
  } else {
    applyOdColletHub();
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.request-quote-button')?.addEventListener('click', function () {
    if (window.SpeedgripAuth && !window.SpeedgripAuth.loggedIn) return;

    var specsField =
      document.querySelector('#CustomSpecifications') ||
      document.querySelector('[name="properties[Custom Specifications]"]');

    var specs = specsField ? specsField.value.trim() : '';

    if (!specs) {
      alert('Please enter your custom specifications before requesting a quote.');
      specsField?.focus();
      return;
    }

    this.closest('form')?.submit();
  });
});

(function replaceLegacyFooter() {
  function injectNewsletterIntoAiFooter(content) {
    if (content.querySelector('[class*="sg-footer-newsletter-"]')) return;

    const logoCol = content.querySelector('[class*="ai-footer-logo-col-"]');
    const centerCol = content.querySelector('[class*="ai-footer-center-"]');
    if (!logoCol || !centerCol) return;

    const suffix = (content.className.match(/ai-footer-content-([^\s]+)/) || [])[1] || 'default';
    const newsletter = document.createElement('div');
    newsletter.className = `sg-footer-newsletter-${suffix}`;
    newsletter.innerHTML = `
      <h2 class="sg-footer-newsletter-heading-${suffix}">stay in the <span class="sg-footer-newsletter-accent-${suffix}">know</span></h2>
      <p class="sg-footer-newsletter-subtext-${suffix}">Be the first to know about new products<br>and industry updates.</p>
      <div class="sg-footer-newsletter-form-${suffix}">
        <form method="post" action="/contact#contact_form" id="newsletter-form-footer-js" accept-charset="UTF-8" class="newsletter-form">
          <input type="hidden" name="form_type" value="customer">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="contact[tags]" value="newsletter">
          <div class="newsletter-form__field-wrapper">
            <div class="field">
              <label class="visually-hidden" for="newsletter-form-footer-js--email">Your Email</label>
              <input id="newsletter-form-footer-js--email" type="email" name="contact[email]" class="field__input" required placeholder="Your Email" autocomplete="email">
            </div>
            <button type="submit" class="button button--primary newsletter-form__button" name="commit" aria-label="Subscribe">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret"><use href="#icon-caret"></use></svg>
            </button>
          </div>
        </form>
      </div>`;

    centerCol.style.marginLeft = '0';
    logoCol.insertAdjacentElement('afterend', newsletter);
  }

  function run() {
    if (document.getElementById('sg-footer-inject-styles')) return;

    const style = document.createElement('style');
    style.id = 'sg-footer-inject-styles';
    style.textContent = `
      [class*="ai-footer-content-"], [class*="sg-footer-content-"] {
        display: grid; grid-template-columns: auto minmax(220px, 1fr) minmax(200px, auto) minmax(160px, auto); align-items: start; gap: 48px;
      }
      [class*="ai-footer-logo-col-"], [class*="sg-footer-logo-col-"] { grid-column: 1; justify-self: start; }
      [class*="sg-footer-contact-col-"] { grid-column: 3; justify-self: center; min-width: 200px; }
      [class*="sg-footer-social-col-"] { grid-column: 4; justify-self: end; min-width: 160px; }
      [class*="ai-footer-center-"] { grid-column: 3; justify-self: end; margin-left: 0 !important; }
      [class*="sg-footer-newsletter-"]:not([class*="heading"]):not([class*="subtext"]):not([class*="form"]):not([class*="accent"]) {
        grid-column: 2; justify-self: start; width: 100%; max-width: 728px; min-width: 220px;
        display: flex; flex-direction: column; gap: 0; align-items: flex-start; text-align: left;
      }
      [class*="sg-footer-newsletter-heading-"] { margin: 0; display: block; flex: none; text-transform: uppercase; font-weight: 700; line-height: 1.1; font-size: 1.25rem; white-space: nowrap; }
      [class*="sg-footer-newsletter-accent-"] { display: inline; color: #1a6421; }
      [class*="sg-footer-newsletter-subtext-"] { margin: 10px 0 0; opacity: 0.85; line-height: 1.4; }
      [class*="sg-footer-newsletter-form-"] { width: 90%; max-width: 90%; position: relative; margin: 10px 0 0; }
      [class*="sg-footer-newsletter-form-"] .newsletter-form__field-wrapper { position: relative; }
      [class*="sg-footer-newsletter-form-"] [type=email] {
        width: 100%; background: transparent; box-shadow: inset 0 0 0 1px rgba(0,0,0,.2); padding-right: 2.75rem; font-size: 15px;
      }
      [class*="sg-footer-newsletter-form-"] .button {
        position: absolute; top: .25rem; right: .25rem; bottom: .25rem;
        min-width: auto; height: auto; padding: calc(.5rem + 3px); font-size: 0; gap: 0;
      }
      [class*="sg-footer-newsletter-form-"] .icon-caret { width: 1rem; height: 1rem; transform: rotate(-90deg); }
      @media (max-width: 768px) {
        [class*="ai-footer-content-"], [class*="sg-footer-content-"] { grid-template-columns: 1fr; gap: 30px; }
        [class*="sg-footer-newsletter-"]:not([class*="heading"]):not([class*="subtext"]):not([class*="form"]):not([class*="accent"]),
        [class*="sg-footer-contact-col-"],
        [class*="sg-footer-social-col-"] {
          grid-column: 1; justify-self: start; max-width: 728px; width: 100%;
        }
        [class*="sg-footer-newsletter-form-"] { width: 100%; max-width: 100%; }
      }`;
    document.head.appendChild(style);

    const legacyFooter = document.querySelector('footer[class*="ai-footer-"]');
    const newFooter = document.querySelector('footer[class*="sg-footer-"]');
    if (newFooter) {
      legacyFooter?.remove();
      return;
    }
    if (!legacyFooter) return;

    const content = legacyFooter.querySelector('[class*="ai-footer-content-"]');
    if (content) injectNewsletterIntoAiFooter(content);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

document.addEventListener('click', (event) => {
  const button = event.target.closest('.product-dimensions__toggle-btn');
  if (!button) return;

  const root = button.closest('.product-dimensions');
  const extra = root?.querySelector('.product-dimensions__extra');
  if (!extra) return;

  const open = extra.hasAttribute('hidden');
  extra.toggleAttribute('hidden', !open);
  root.classList.toggle('is-open', open);
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
});
